import { Icon } from "../icon/Icon";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens } from "@voltmoney/schema";
import { Space } from "../space/Space";
import { Typography } from "../typography/Typography";
import { View } from "react-native";
import React from "react";
export const SecureWithUs = () => {
    return (React.createElement(View, { style: {
            alignContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
        } },
        React.createElement(Icon, { name: IconTokens.Secure, size: IconSizeTokens.XS, color: ColorTokens.Secondary_100 }),
        React.createElement(Space, { size: SizeTypeTokens.XS }),
        React.createElement(Typography, { label: 'Your data is secure with us', fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })));
};
